import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import UsersList from './UsersList';

//redux

const Users = () => {
	const breadcrumbLinks = [{ to: '#', label: 'Inicio', icon: 'icon-house' }];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Usuarios' links={breadcrumbLinks} icon={'icon-user-round-cog'} />
					<UsersList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Users;
